module.exports = __webpack_public_path__ + "static/media/video.ed44dc5d.mp4";